import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import "./NotificationAdd.css";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const DeliveryNotificationAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";

  const [heading, setHeading] = useState("");
  const [notification, setNotification] = useState("");

  useEffect(() => {
    if (data) {
      setHeading(data?.title || data?.description || "");
      setNotification(data?.description || "");
    }
  }, [data]);

  const handleSubmit = async () => {
    if (!heading || !notification) {
      toast.error("Please fill in all required fields");
      return;
    }

    const payload = {
      send_to: "all",
      title: heading,
      description: notification,
      user_ids: [],
    };
    console.log("Notification Payload:", payload);

    try {
      let res = await post(URLS.DELIVERYPUSHNOTIFICATION, payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Notification sent successfully");
        navigate("/delivery-notifications", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to send notification");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error(error?.message || "Failed to send notification");
    }
  };

  return (
    <>
      <PageHeader
        title={isViewMode ? "View Notification" : "Delivery Push Notifications"}
        showBackButton={true}
        onBackClick={() =>
          navigate("/delivery-notifications", { state: { page: page || 1 } })
        }
      />
      <div className="notification-add-container">
        <div className="notification-add-form">
          {/* User Type Selection */}
          <div
            className="user-type-section"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="radio-group">
              <label
                className={`radio-option active ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="all"
                  checked
                  readOnly
                  disabled={isViewMode}
                />
                <span className="radio-label">All Users</span>
              </label>
            </div>
          </div>

          {/* Heading */}
          <div className="form-group">
            <label>Heading</label>
            <input
              type="text"
              value={heading || ""}
              onChange={(e) => setHeading(e.target.value)}
              placeholder="Notification Heading!"
              disabled={isViewMode}
            />
          </div>

          {/* Notification */}
          <div className="form-group">
            <label>Notification</label>
            <textarea
              value={notification || ""}
              onChange={(e) => setNotification(e.target.value)}
              placeholder="Message!"
              rows={4}
              disabled={isViewMode}
            />
          </div>

          {/* Action Buttons */}
          {!isViewMode && (
            <div className="form-actions">
              <button
                type="button"
                className="btn-edit"
                onClick={() =>
                  navigate("/notifications", { state: { page: page || 1 } })
                }
              >
                Back
              </button>
              <button
                type="button"
                className="btn-submit"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DeliveryNotificationAdd;
